export const customNodeStyles = {
    nodeConatiner: {
        textAlign: "left",
        padding: "20px",
        boxShadow: "1px 1px 1px 1px #D3D3D3",
        borderRadius: "10px",
        // width: "190px",
    },
    moduleName: {
        fontSize: '12px',
        fontFamily: "Poppins",
        fontWeight: 700,
        color: "#333333",
        maxWidth: '15ch',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        cursor: 'default'
    },
    lastRunTitle: {
        color: "#929497",
        fontFamily: "Poppins",
        fontSize: "10px",
        marginTop: "12px",
        fontWeight: 700
    },
    dateAndTimeDetails: {
        fontSize: "10px",
        fontFamily: "Poppins",
        fontWeight: 700,
        marginTop: "5px",
        color: "#59595A",
    },
    statusButton: {
        fontSize: "12px",
        border: "none",
        borderRadius: "20px",
        padding: "5px 10px",
        marginTop: "10px",
        maxWidth: '10ch',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        cursor: 'default'
    }
};